import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import axios from 'axios';
import * as serviceWorker from 'serviceWorker';

import App from 'App';
import { store, attach500Handler } from 'helpers';
import { axiosInstance as cachedAxiosInstance } from 'helpers/cacheApiClient';
import { credentialsAxios, studioAxios } from 'services/integrations';
import 'assets/sass/style.scss';

[axios, credentialsAxios, studioAxios, cachedAxiosInstance].forEach(attach500Handler);

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
